import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import { PhoneField, TextField, EmailField, useFieldHelper } from 'framework/ui/field';
import { Grid2 as Grid, Box } from '@mui/material';
import { TabsWrapper } from 'framework/ui/TabsWrapper';
import { LedgerLink } from 'domain/shared/ledger';
import { SectionRow, BigSectionRow } from 'framework/ui/layout';

const ContactsVendor = () => {
  const { getValue } = useFieldHelper<any[]>({ source: 'contacts' });
  const contacts = getValue() || [];

  return (
    <>
      <SectionRow colMd={6} colXl={6}>
        <PhoneField label="General vendor phone" source="phoneNumber" />
        <EmailField label="General vendor email" source="email" />
      </SectionRow>
      {contacts.map((contact: any, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <SectionRow key={index} colMd={6} colXl={6}>
          <TextField value={contact.name} />
          <Box>
            <PhoneField value={contact.phoneNumber} />
            <EmailField value={contact.email} />
          </Box>
        </SectionRow>
      ))}
    </>
  );
};

const RequisitesVendor = () => {
  return (
    <Grid container columnGap="10px" rowGap="10px" mb="20px" justifyContent="space-between">
      <Grid size={{ xs: 12, md: 5 }}>
        <TextField label="Tax registration number" source="taxRegistrationNumber" />
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <LedgerLink source="costCenterId" nameSource="costCenterId" label="Cost center" />
      </Grid>
    </Grid>
  );
};

const ShowVendorProfile = () => {
  return (
    <>
      <SectionRow
        colXl={10}
        sxItem={{
          mb: '15px !important',
        }}
      >
        <EmployeeLinkFieldWithNameLoading source="owner" label="" />
      </SectionRow>

      <BigSectionRow>
        <TextField
          isVisible={(data: any) => !!data.getValueBySource('nextReviewDate')}
          label="Next review date"
          source="nextReviewDate"
        />
      </BigSectionRow>

      <Box mb="20px">
        <TextField label="Purpose" source="purpose" />
      </Box>

      <TabsWrapper
        sxTabs={{
          '.MuiTabs-flexContainer div': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          },
        }}
        sxContentProps={{}}
        tabs={[
          {
            label: 'Contacts',
            content: <ContactsVendor />,
          },
          {
            label: 'Requisites',
            content: <RequisitesVendor />,
          },
        ]}
      />
    </>
  );
};

export default ShowVendorProfile;
